import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './smartphones.json';

const Smartphones = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Mobile technology, apps, and digital wellbeing vocabulary. B2 level English exercises with grammar, reading, and discussion."
            level="B2"
            title="Smart Phones"
            image="/Images/cellphone1.webp"
            seoTitle="Free English Lesson Plans: Smartphones"
            seoDescription="Mobile technology, apps, and digital wellbeing vocabulary. B2 level English exercises with grammar, reading, and discussion."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Smartphones;


